import { SkillStatusTypes, SkillsType } from '@/constants/skillStatuses';

import alphSort from '@/helpers/alphabeticallSort';

const defaultSkillsFilter = {
	jobTitleId: [],
	departmentId: [],
};

export default {
	state: {
		preselectedSkills: [],
		skillsForSearch: [],
		skillsFilter: defaultSkillsFilter,
	},
	mutations: {
		REMOVE_PRESELECTED_SKILL: (state, skillData) => {
			const { name, type } = skillData;
			state.preselectedSkills = state.preselectedSkills.filter((skill) => skill.name !== name);
			const skillIndexInTable = state.skillsForSearch.findIndex(
				(preSkill) => preSkill.name === name,
			);
			if (
				state.skillsForSearch[skillIndexInTable]
				&& state.skillsForSearch[skillIndexInTable].skillType
			) {
				state.skillsForSearch[skillIndexInTable].skillType = SkillsType.USER === type
					? SkillStatusTypes.NO_EXPERIENCE
					: SkillStatusTypes.NOT_REQUIRED;
			}
			state.selectedSkills = [];
		},
		SET_PRESELECTED_SKILLS: (state, skills) => {
			state.preselectedSkills = alphSort(skills, 'skillType');
		},
		ADD_PRESELECTED_SKILLS: (state, skill) => {
			state.preselectedSkills = alphSort([...state.preselectedSkills, skill], 'skillType');
		},
		SET_SKILLS_DEFAULT_FILTER: (state) => {
			const newFilter = {
				...defaultSkillsFilter,
				jobTitleId: [...defaultSkillsFilter.jobTitleId],
				departmentId: [...defaultSkillsFilter.departmentId],
			};
			state.skillsFilter = newFilter;
		},
		CHANGE_SKILL_TYPE: (state, { index, type }) => {
			state.preselectedSkills = state.preselectedSkills.map((skill, skillIndex) => {
				if (index === skillIndex) {
					return ({ ...skill, skillType: type });
				} return skill;
			});
		},
		SET_SKILLS_FILTER: (state, filters) => {
			state.skillsFilter = filters;
		},
		ADD_SKILL_SEARCH: (state, skill) => {
			state.skillsForSearch = alphSort([...state.skillsForSearch, skill], 'skillType');
		},
		SET_SKILLS_SEARCH: (state, skills) => {
			state.skillsForSearch = alphSort(skills, 'skillType');
		},
		SET_DEFAULT_STATE: (state) => {
			state.preselectedSkills = [];
			state.skillsForSearch = [];
		},
	},
	getters: {
		preselectedSkills: (state) => state.preselectedSkills,
		preselectedSkillsToShow: (state) => state.preselectedSkills
			.filter((skillItem) => skillItem.skillType !== SkillStatusTypes.NO_EXPERIENCE),
		skillsForSearch: (state) => state.skillsForSearch,
		skillsFilter: (state) => state.skillsFilter,
	},
	actions: {
		loadSkillsOnChange: async ({ commit, dispatch }, params) => {
			try {
				const preselectedSkills = await dispatch('loadSkills', params);
				commit('SET_PRESELECTED_SKILLS', preselectedSkills);
			} catch (error) {
				this.$toaster.error(error?.body?.error?.message || 'Something went wrong.');
			}
		},
		setPreselectedSkills: ({ commit }, skills) => {
			commit('SET_PRESELECTED_SKILLS', skills);
		},
		addPreselectedSkill: ({ commit }, skill) => {
			commit('ADD_PRESELECTED_SKILLS', skill);
		},
		removeSkillFromPreselected: ({ commit }, skillData) => {
			commit('REMOVE_PRESELECTED_SKILL', skillData);
		},
		setDefaultSkillsState: ({ commit }) => {
			commit('SET_DEFAULT_STATE');
		},
		setSkillsSearch: ({ commit }, skills) => {
			commit('SET_SKILLS_SEARCH', skills);
		},
		setDefaultSkillsFilter: ({ commit }) => {
			commit('SET_SKILLS_DEFAULT_FILTER');
		},
		setSkillsFilter: ({ commit }, filter) => {
			commit('SET_SKILLS_FILTER', filter);
		},
		changeSkillStatus: ({ commit }, data) => {
			commit('CHANGE_SKILL_TYPE', data);
		},
	},
};
